export const HOST = process.env.HOST;
export const WECHAT = process.env.WECHAT
export const PLATFORMHOST = process.env.PLATFORMHOST
export const SOCKETIP = process.env.SOCKETIP
export const SIG = "token"



// WEBPACK FOOTER //
// ./src/common/config.js